
import MainContainer from "@/components/layout/mainContainer/MainContainer.vue";
import CustomButton from "@/components/inputs/customButton/CustomButton.vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "404Index",
  components: { MainContainer, CustomButton },
});
